import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class LabelResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.pk = () => this.label?.key || this.tooltip?.key;
    }
}
LabelResource.urlRoot = apiResourceUrl("resources/labels");
export { LabelResource };
//# sourceMappingURL=LabelResource.js.map